// extracted by mini-css-extract-plugin
export default {"textArea":"CardSettingsCommonPage_textArea__jxa3D"};